import { createStore } from "vuex";
import { auth } from "./auth";
import { files } from "./files";
import { todo } from "./todo";
import { view } from "./view";
import { theme } from "./theme";
import { setting } from "./setting";
import { media } from "./media";
import { favorite } from "./favorite";
import { image } from "./image";
import { subtitle } from "./subtitle";
import { onenote } from "./onenote";
import { diary } from "./diary";
import share from "./share";
import createPersistedState from "vuex-persistedstate";

const persistPaths = [
    "auth",
    "todo",
    "view",
    "theme",
    "setting"
];

if (process.env.NODE_ENV === "development") {
    persistPaths.push("files");
}

const store = createStore({
    modules: {
        auth,
        files,
        todo,
        view,
        theme,
        setting,
        media,
        favorite,
        image,
        subtitle,
        share,
        onenote,
        diary,
    },
    plugins: [
        createPersistedState({
            paths: persistPaths
        })
    ],
});

setInterval(() => {
    if (store.state.auth.status.loggedIn) {
        store.commit("auth/updateRemaining");
    }
}, 1000);

export default store;